/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum InvoiceChallengeMode {
  PerAudit = "PerAudit",
  Combined = "Combined",
}

export function instanceOfInvoiceChallengeMode(value: any): boolean {
  for (const key in InvoiceChallengeMode) {
    if (Object.prototype.hasOwnProperty.call(InvoiceChallengeMode, key)) {
      if (
        InvoiceChallengeMode[key as keyof typeof InvoiceChallengeMode] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function InvoiceChallengeModeFromJSON(json: any): InvoiceChallengeMode {
  return InvoiceChallengeModeFromJSONTyped(json, false);
}

export function InvoiceChallengeModeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InvoiceChallengeMode {
  return json as InvoiceChallengeMode;
}

export function InvoiceChallengeModeToJSON(
  value?: InvoiceChallengeMode | null,
): any {
  return value as any;
}

export function InvoiceChallengeModeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): InvoiceChallengeMode {
  return value as InvoiceChallengeMode;
}
